<script>
	import {Types} from './song.js'
	import {type2Style} from './lists.js'
	import Text from './typedtext.svelte'
	import Editable from './editablelabel.svelte'
	import Tags from './tags.svelte'
	import Stars from './stars.svelte'
	import Metronome from './metronome.svelte'
	import SongLinks from './songlinks.svelte'
	import Rating from './rating.svelte'
	import Edit from './edit.svelte'

	export let song = {}
	export let params;
	let metro = {}
	let lastTempo = 0;

	export function stopMetronome() {
		if (song.tempo == lastTempo)
			metro.stopTick();
	}

	function rate(stars) {
		song.rate(stars);
		params.rating = stars;
		song = song;
	}

	function updateAct(op) {
		song[op]();
		song = song;
	}

</script>

<div>
	<Stars stars={song.stars}/>
	<Editable bind:value={song.name}/>
	{#if params.config.showScore && song.last}({Math.round(song.getScore())}){/if}
	{#if song.key}v {song.key}{/if}
	{#if song.books} zpěvník: {song.books}{/if}
</div>

<Tags bind:labels={song.tags}/>
<Metronome bind:tempo={song.tempo} bind:lastTempo={lastTempo} bind:this={metro}/>
<SongLinks bind:song={song}/>
<div>
	{#if song.type == Types.QUEUE}
		písnička je ve <Text label={"frontě"} type={Types.QUEUE} />
		když ji ohodnotíš, přesune se do <Text label={"učení"} type={Types.LEARNING} />
	{/if}
	{#if song.type == Types.LEARNING}
		Písničku se <Text label={"učíš"} type={Types.LEARNING} />
	{/if}
	{#if song.type == Types.DONE}
		Písničku už <Text label={"umíš"} type={Types.DONE} /> takže opakujeme
	{/if}
	<br>
	Jak to dopadlo?
	{#if song.type == Types.DONE}
		<button class="typebtn" style={type2Style(Types.FORGOTTEN)} on:click={e => updateAct("toForgotten")}>zapomněl jsem to :-(</button>
	{:else if song.type == Types.LEARNING || song.type == Types.FORGOTTEN}
		<button class="typebtn" style={type2Style(Types.QUEUE)} on:click={e => updateAct("toQueue")}>vrátit do fronty :-(</button>
	{/if}
	<Rating bind:rating={params.rating} on:rate={e => rate(e.detail)}/>
	{#if song.type != Types.DONE}
		<button class="typebtn" style={type2Style(Types.DONE)} on:click={e => updateAct("toDone")}>už to umím!</button>
	{/if}
</div>
<Edit bind:song={song}/>
